import PropTypes from 'prop-types'
import { objectGroupPropType } from './object-group-prop-type'

/**
 * @typedef {Object.<Id, ObjectGroup>} ObjectGroups
 */
export const objectGroupsPropType = PropTypes.objectOf(objectGroupPropType)
